import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonModule, DOCUMENT } from '@angular/common';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommanService } from './comman.service';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  readonly ApiUrl: string = environment.appUrl;
  private currentUserSubject: BehaviorSubject<any> = new BehaviorSubject({});
  private loginUser = new BehaviorSubject<boolean>(false);
  private token_checked = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private commanService: CommanService) {
    this.getSavedUser();
    // Add the storage event listener here in the constructor
    window.addEventListener('storage', (event) => {
      console.log('Storage event detected:', event); // Debugging log
      if (event.key === 'auth-event') {
        if (event.newValue === 'login') {
          console.log('Login event detected from another tab'); // Debugging log
          const savedUser = localStorage.getItem('currentUser');
          if (savedUser) {
            console.log('User found in localStorage:', savedUser); // Debugging log
            this.sendCurrentUserSubject(JSON.parse(savedUser));
            this.sendLoginUser(true);
          }
        } else if (event.newValue === 'logout') {
          console.log('Logout event detected from another tab'); // Debugging log
          this.sendCurrentUserSubject({});
          this.sendLoginUser(false);
        }
      }
    });
  }
  getSavedUser() {
    const savedUser = localStorage.getItem('currentUser');
    if (savedUser) {
      const parsedUser = JSON.parse(savedUser);
      this.sendCurrentUserSubject(parsedUser);
      this.sendLoginUser(true);

      // ✅ Restore privilege from localStorage if present
      const savedPrivilege = localStorage.getItem('user_privilege');
      if (savedPrivilege) {
        const parsedPrivilege = JSON.parse(savedPrivilege);
        // Push privilege into CommanService for global availability
        this.commanService.setUserPrivilege(parsedPrivilege);
      }
    }
  }

  // login(postdata: {}): Observable<any> {
  //   return this.http.post<any>(`${ this.ApiUrl } / signin`, postdata)
  //     .pipe(map(user => {
  //       // store user details and jwt token in local storage to keep user logged in between page refreshes
  //       localStorage.setItem('currentUser', JSON.stringify(user));
  //       this.currentUserSubject.next(user);
  //       this.startRefreshTokenTimer();
  //       return user;
  //     }));
  // }
  login(postdata: {}): Observable<any> {
    return this.http
      .post<any>(`${this.ApiUrl}/api/v2/user/auth-login`, postdata)
      .pipe(
        map((user) => {
          // Check if user is active/inactive
          if (user && (user.status === 'inactive' || user.is_active === false || user.is_active === 0 || user.is_active === '0' || user.isActive === false || user.status === 0)) {
            throw new Error('User is inactive');
          }
          localStorage.setItem('currentUser', JSON.stringify(user));

          const rawPrivileges = user?.user_privilege?.[`user_${user.userid}`];

          if (rawPrivileges) {
            const formattedPrivileges: any = {};

            Object.keys(rawPrivileges).forEach((appKey) => {
              const priv = rawPrivileges[appKey];
              formattedPrivileges[appKey] = {
                View: priv.View === 'true',
                Download: priv.Download === 'true',
                Search: Number(priv.Search || 0),
                DownloadCount: Number(priv.DownloadCount || 0),
                DailySearchLimit: Number(priv.DailySearchLimit || 0),
                DailyDownloadLimit: Number(priv.DailyDownloadLimit || 0),
                InitialSearchCount: Number(priv.InitialSearchCount || 0),
                InitialDownloadCount: Number(priv.InitialDownloadCount || 0),
                ReportLimit: Number(priv.ReportLimit || 0),
                SplitDownload: priv.SplitDownload === 'true',
                PageLimit: Number(priv.PageLimit || 0),
                GraphDownload: priv.GraphDownload === 'true',
                GraphDownloadCount: Number(priv.GraphDownloadCount || 0),
                today_search_count: 0,
                today_download_count: 0,
              };
            });

            // Save formatted privileges to localStorage
            localStorage.setItem(
              'user_privilege',
              JSON.stringify(formattedPrivileges)
            );

            // 🚀 FIX: Push current privilege to commanService
            const appName = 'agropat-ultimate-discovery-suite-beta';
            if (formattedPrivileges[appName]) {
              this.commanService.setUserPrivilege(formattedPrivileges[appName]);
            }
          }

          localStorage.setItem('auth-event', 'login');
          this.currentUserSubject.next(user);
          this.sendLoginUser(true);
          this.startRefreshTokenTimer();
          return user;
        })
      );
  }

  user_login(postdata: {}): Observable<any> {
    return this.http
      .post<any>(`${this.ApiUrl}/api/v2/user/auth-login`, postdata)
      .pipe(
        map((user) => {
          // Check if user is active/inactive
          if (user && (user.status === 'inactive' || user.is_active === false || user.is_active === 0 || user.is_active === '0' || user.isActive === false || user.status === 0)) {
            throw new Error('User is inactive');
          }
          localStorage.setItem('currentUser', JSON.stringify(user));

          const userId = user?.userid;
          const rawPrivileges = user?.user_privilege?.[`user_${userId}`];
          const appName = 'agropat-ultimate-discovery-suite-beta';

          console.log('🔍 Login - rawPrivileges:', rawPrivileges);

          if (rawPrivileges && rawPrivileges[appName]) {
            let privilegeForApp = rawPrivileges[appName];

            console.log(
              '🔍 Login - privilegeForApp BEFORE unwrap:',
              privilegeForApp
            );

            // ✅ Unwrap if already nested in server response
            while (privilegeForApp && privilegeForApp[appName]) {
              console.warn('⚠️ Server returned nested privilege!');
              privilegeForApp = privilegeForApp[appName];
            }

            console.log(
              '✅ Login - privilegeForApp AFTER unwrap:',
              privilegeForApp
            );

            const normalizedPrivilege: any = {
              ...privilegeForApp,
              View: privilegeForApp.View === true || privilegeForApp.View === 'true',
              Download: privilegeForApp.Download === true || privilegeForApp.Download === 'true',
              Search: Number(privilegeForApp.Search || 0),
              DailySearchLimit: Number(privilegeForApp.DailySearchLimit || 0),
            };

            // This should now save the normalized flat object
            this.commanService.setUserPrivilege(normalizedPrivilege);
          }

          this.currentUserSubject.next(user);
          this.sendLoginUser(true);
          this.startRefreshTokenTimer();
          return user;
        })
      );
  }

  auto_login(accesskey: {}): Observable<any> {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/auto-login`, accesskey).pipe(
      map((user) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user));
        // this.currentUserSubject.next(user);
        this.startRefreshTokenTimer();
        return user;
      })
    );
  }
  auto_login2(accesskey: any): Observable<any> {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/auto-login`, { accesskey })
      .pipe(map(user => {
        localStorage.setItem('currentUser', JSON.stringify(user));
        
    const userId = user?.userid || user?.id || user?.userId;
    const userPriv = user?.user_privilege?.[user ? `user_${userId}` : '']?.['agropat-ultimate-discovery-suite-beta'] || null;
    if (userPriv) {
      localStorage.setItem('userPrivilege', JSON.stringify(userPriv));
      localStorage.setItem('user_privilege', JSON.stringify(userPriv));
    }
    if (this.sendCurrentUserSubject) this.sendCurrentUserSubject(user);
    if (this.currentUserSubject) this.currentUserSubject.next(user);
    if (this.sendLoginUser) this.sendLoginUser(true);
    
        this.startRefreshTokenTimer();
        return user;
      }));
  }

  // logout() {
  //   // remove user from local storage and set current user to null
  //   localStorage.removeItem('currentUser');
  //   this.sendCurrentUserSubject({});
  //   this.sendLoginUser(false);
  // }
  logout() {
    // Remove the user from localStorage
    localStorage.removeItem('currentUser');

    // Broadcast logout event
    localStorage.setItem('auth-event', 'logout'); // Notify other tabs

    this.currentUserSubject.next({});
    this.sendLoginUser(false);
  }

  refreshToken() {
    let currentuser = localStorage.getItem('currentUser');
    let var_userid = 0;
    let email = '';
    if (currentuser) {
      let userdata = JSON.parse(currentuser);
      var_userid = userdata.userid || userdata.id;
      email = userdata.email;
    }
    return this.http
      .post<any>(`${this.ApiUrl}/api/v2/user/refresh-token`, {
          userid: var_userid,
        email: email,
      })
      .pipe(
        map((user) => {
          localStorage.setItem('currentUser', JSON.stringify(user));
          
    const userId = user?.userid || user?.id || user?.userId;
    const userPriv = user?.user_privilege?.[user ? `user_${userId}` : '']?.['agropat-ultimate-discovery-suite-beta'] || null;
    if (userPriv) {
      localStorage.setItem('userPrivilege', JSON.stringify(userPriv));
      localStorage.setItem('user_privilege', JSON.stringify(userPriv));
    }
    if (this.sendCurrentUserSubject) this.sendCurrentUserSubject(user);
    if (this.currentUserSubject) this.currentUserSubject.next(user);
    if (this.sendLoginUser) this.sendLoginUser(true);
    
          this.startRefreshTokenTimer();
          return user;
        })
      );
  }

  getUserPrivilege() {
    const privilege = localStorage.getItem('user_privilege');
    return privilege ? JSON.parse(privilege) : null;
  }

  getCurrentUserValue(): any {
    return (
      this.currentUserSubject.asObservable() ||
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
  }

  // helper methods

  private refreshTokenTimeout: any;

  private startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    // const jwtToken = JSON.parse(atob(this.currentUserValue.token.split('.')[1]));
    // set a timeout to refresh the token a minute before it expires
    // const expires = new Date(jwtToken.exp * 1000);
    // const timeout = expires.getTime() - Date.now() - (60 * 1000);
    // this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }

  sendLoginUser(data: any) {
    this.loginUser.next(data);
  }

  getLoginUser() {
    return this.loginUser.asObservable();
  }

  sendCurrentUserSubject(data: any) {
    this.currentUserSubject.next(data);
  }

  // getCurrentUserSubject() {
  //   return this.currentUserSubject.asObservable();
  // }

  sendTokenChecked(data: any) {
    this.token_checked.next(data);
  }

  getTokenChecked() {
    return this.token_checked.asObservable();
  }
}
